import { render, staticRenderFns } from "./PurchaseLimitHint.vue?vue&type=template&id=13321ba2&scoped=true"
import script from "./PurchaseLimitHint.vue?vue&type=script&lang=ts"
export * from "./PurchaseLimitHint.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseLimitHint.vue?vue&type=style&index=0&id=13321ba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13321ba2",
  null
  
)

export default component.exports